import Vue from 'vue';
import { config } from 'CONFIG';
import VueI18n, { LocaleMessageObject } from 'vue-i18n';
import numberFormats from '@/lang/numberFormats';
import { getFeature, getCookie } from '@/common/js/utils';
import { isApp } from '@/utils/business';

Vue.use( VueI18n );

export const LANG_KEY = isApp ? 'REO_LANGUAGE' : 'REO_CLOUD_LANGUAGE';
const LANG = getCookie( LANG_KEY )?.slice( 0, 2 ) ?? config.lang;

const resolvedLang = !getFeature( 'main.multi_language' ) ? ( LANG ?? config.lang ) : config.lang;
/** 线上历史使用 jp，标准 locale 为 ja（BCP 47 / ISO 639-1） */
export const lang = resolvedLang === 'jp' ? 'ja' : resolvedLang;
const langFiles = import.meta.glob<LocaleMessageObject>( './*.json', {
    eager: true,
    import: 'default'
});
const messages = Object.fromEntries(
    Object.entries( langFiles ).map(( [ key, value ] ) => {

        const langKey = ( /\/([a-zA-Z-_]+)\.json$/.exec( key ))?.[1 ] ?? '';
        return [ langKey, value ];
    
    })
);

if ( messages.ja ) {

    messages.jp = messages.ja;

}

const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'en',
    messages,
    numberFormats
});

export default i18n;
